import { setScrollbarWidth } from './setScrollbarWidth';
var Popup = /** @class */ (function () {
    function Popup(data) {
        var _this = this;
        this.handleEscape = function (evt) {
            if (evt.key === 'Escape') {
                _this.close();
            }
        };
        this.popupElement = data.popupElement;
        this.closeButtonClass = data.closeButtonClass;
    }
    Popup.prototype.setEventListeners = function () {
        var _this = this;
        this.popupElement.addEventListener('click', function (evt) {
            var target = evt.target;
            if (target.classList.contains('open') || target.classList.contains(_this.closeButtonClass)) {
                _this.close();
            }
        });
    };
    Popup.prototype.open = function () {
        this.popupElement.classList.add('open');
        setScrollbarWidth();
        document.body.classList.add('no-scroll');
        document.addEventListener('keydown', this.handleEscape.bind(this));
    };
    Popup.prototype.close = function () {
        this.popupElement.classList.remove('open');
        document.body.classList.remove('no-scroll');
        document.removeEventListener('keydown', this.handleEscape.bind(this));
    };
    return Popup;
}());
export { Popup };
